import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/img/plan/man2 1.png")